import {
  getTimeSlotsConfiguration as publicGetTimeSlotsConfiguration,
  getTimeSlotsConfigurationByAppId as publicGetTimeSlotsConfigurationByAppId,
  updateTimeSlotsConfiguration as publicUpdateTimeSlotsConfiguration,
  queryTimeSlotsConfigurations as publicQueryTimeSlotsConfigurations,
  typedQueryTimeSlotsConfigurations as publicTypedQueryTimeSlotsConfigurations,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  TimeSlotsConfigurationQuery,
  TimeSlotsConfigurationsQueryBuilder,
  typedQueryTimeSlotsConfigurations as universalTypedQueryTimeSlotsConfigurations,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';

function customQueryTimeSlotsConfigurations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () =>
      publicQueryTimeSlotsConfigurations(httpClient)(),
    typedQueryFunction: (query: TimeSlotsConfigurationQuery) =>
      publicTypedQueryTimeSlotsConfigurations(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): TimeSlotsConfigurationsQueryBuilder;
  function overloadedQuery(
    query: TimeSlotsConfigurationQuery
  ): ReturnType<typeof universalTypedQueryTimeSlotsConfigurations>;
  function overloadedQuery(query?: TimeSlotsConfigurationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const getTimeSlotsConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicGetTimeSlotsConfiguration> &
    typeof publicGetTimeSlotsConfiguration
> = /*#__PURE__*/ createRESTModule(publicGetTimeSlotsConfiguration);
/** @internal */
export const getTimeSlotsConfigurationByAppId: MaybeContext<
  BuildRESTFunction<typeof publicGetTimeSlotsConfigurationByAppId> &
    typeof publicGetTimeSlotsConfigurationByAppId
> = /*#__PURE__*/ createRESTModule(publicGetTimeSlotsConfigurationByAppId);
/** @internal */
export const updateTimeSlotsConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTimeSlotsConfiguration> &
    typeof publicUpdateTimeSlotsConfiguration
> = /*#__PURE__*/ createRESTModule(publicUpdateTimeSlotsConfiguration);
export const queryTimeSlotsConfigurations: MaybeContext<
  BuildRESTFunction<typeof customQueryTimeSlotsConfigurations> &
    typeof customQueryTimeSlotsConfigurations
> = /*#__PURE__*/ createRESTModule(customQueryTimeSlotsConfigurations);

export {
  BasedOn,
  Strategy,
  SortOrder,
  WebhookIdentityType,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';
export {
  TimeSlotsConfiguration,
  DisplayTimeZone,
  StaffSelection,
  SplitInterval,
  ExtendedFields,
  CreateTimeSlotsConfigurationRequest,
  CreateTimeSlotsConfigurationResponse,
  GetTimeSlotsConfigurationRequest,
  GetTimeSlotsConfigurationResponse,
  GetTimeSlotsConfigurationByAppIdRequest,
  GetTimeSlotsConfigurationByAppIdResponse,
  UpdateTimeSlotsConfigurationRequest,
  UpdateTimeSlotsConfigurationResponse,
  QueryTimeSlotsConfigurationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryTimeSlotsConfigurationsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdateTimeSlotsConfiguration,
  TimeSlotsConfigurationsQueryResult,
  TimeSlotsConfigurationsQueryBuilder,
  TimeSlotsConfigurationQuerySpec,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';
export { utils } from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';
export {
  BasedOnWithLiterals,
  StrategyWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  TimeSlotsConfigurationQuery,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';
